import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import img0 from "../images/DSC07925_VSCO.jpg";
import img2 from "../images/DSC01638_VSCO.jpg";
import img1 from "../images/IMG_3141_VSCO.jpg";
import img3 from "../images/IMG_3125_VSCO.jpg";
import img4 from "../images/DSC02182_VSCO.jpg";
import img5 from "../images/IMG_3162_VSCO.jpg";


const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};

const stagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12
    }
  }
};

type InstagramService = {
  img: string;
  title: string;
  price: string;
  number: string;
  desc: string;
};

const instagramServices: InstagramService[] = [
  {
    img: img4,
    title: "Insta Starter Girl",
    price: "90 € / mois",
    number: "01",
    desc: `Pour celles qui veulent être guidées et ne plus avancer seules.

    Chaque mois :
      - 1 visio d’1h ensemble
      - On répond à tes questions et à tes blocages
      - Analyse de ton compte rapide
      - Conseils personnalisés pour améliorer ton contenu.`
  },
  {
    img: img3,
    title: "Insta Boost Girl",
    price: "400 € / mois",
    number: "02",
    desc: `Pour celles qui veulent vraiment développer leur compte.

    4h d’accompagnement par mois.

    Ce qu’on fait ensemble :
      - Mise en application complète de la méthode de l’e-book
      - Analyse et optimisation de ton contenu
      - Ajustement de ton positionnement
      - Conseils pour développer ta visibilité
      - 1 visio chaque semaine pour avancer étape par étape`
  },
  {
    img: img5,
    title: "Insta Signature Girl",
    price: "600 € / mois",
    number: "03",
    desc: `Pour celles qui veulent construire une vraie stratégie Instagram.

    8h d’accompagnement par mois.

    Ce qu’on met en place :
      - Élaboration d’une mini stratégie personnalisée
      - Création d’une ligne directrice claire
      - Positionnement et message de marque
      - Mise en application complète de la méthode
      - 2 visios de 2h pour travailler en profondeur`
  },
  {
    img: img1,
    title: "Insta Queen Girl",
    price: "850 € / mois",
    number: "04",
    desc: `L’accompagnement premium pour celles qui veulent passer un vrai cap.

    10h d’accompagnement par mois.

    Ce qu’on construit ensemble :
      - Stratégie Instagram personnalisée
      - Application complète de la méthode
      - Création et optimisation de contenu
      - Développement de ta visibilité
      - Conseils business et communication

    Un accompagnement profond pour transformer ton Instagram en véritable levier de business.
    (hors frais de déplacement)`
  }
];

const Services: React.FC = () => {

  return (
    <div className="bg-[#f5f3ef] text-[#1a1a1a]">
      {/* HERO */}

      <section className="h-[70vh] relative flex items-center overflow-hidden">

        <motion.img
          src={img0}
          className="absolute w-full h-full object-cover"
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 6 }}
        />

        <div className="absolute inset-0 bg-black/30"></div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="relative max-w-6xl px-10 text-white"
        >

          <p className="text-sm mb-4 opacity-80">
            Mes services
          </p>

          <h1 className="text-6xl md:text-7xl font-light leading-tight max-w-3xl">
            Des images qui racontent
            <br />
            l’histoire de ta marque.
          </h1>

        </motion.div>

      </section>



      {/* SHOOTING SERVICE */}

      <motion.section
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="max-w-6xl mx-auto px-10 py-28 grid md:grid-cols-2 gap-16 items-center"
      >

        <div>

          <p className="text-sm text-neutral-500 mb-4">
            Shooting photo
          </p>

          <h2 className="text-4xl mb-6">
            Shooting "One Shot"
          </h2>

          <p className="text-2xl mb-6 font-bold text-neutral-700">
            À partir de 70 €
          </p>

          <p className="text-neutral-600 mb-6 leading-relaxed">
            Un format simple, flexible et pensé pour t’offrir un contenu authentique et impactant, sans prise de tête.
          </p>

          <p className="text-neutral-600 mb-6 leading-relaxed">
            Le temps du shooting varie (1h ou plus) selon ton domaine d’activité, ton univers et ce que tu veux raconter.
            Selon ton projet, il faudra aussi prévoir 1h ou plus pour les retouches photos et le montage vidéo.
          </p>

          <p className="text-neutral-600 mb-8 leading-relaxed">
            On crée ensemble des visuels naturels,
            authentiques et impactants pour faire
            rayonner ton business.
          </p>

          <Link
            to="/contact"
            className="bg-black text-white px-8 py-4 rounded-full inline-block hover:scale-105 transition"
          >
            Réserver mon shooting
          </Link>

        </div>


        <motion.img
          src={img2}
          className="w-full h-[500px] object-cover rounded-xl shadow-xl"
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        />

      </motion.section>


{/* INSTAGRAM ACCOMPAGNEMENT */}

      <section className="max-w-6xl mx-auto px-10 pb-32">

        {/* HEADER */}

        <div className="mb-24">

          <p className="text-sm text-neutral-500 mb-4 tracking-wide">
            Accompagnement Instagram
          </p>

          <h2 className="text-5xl font-light max-w-2xl leading-tight">
             Parce qu’une communication qui touche, c’est une communication qui ose être humaine, sensible, impactante.
          </h2>

        </div>


        {/* LIST */}

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="flex flex-col gap-16"
        >

{instagramServices.map((service) => (

            <motion.div
              key={service.number}
              variants={fadeUp}
              whileHover={{ y: -6, scale: 1.008 }}
              transition={{ type: "spring", stiffness: 220, damping: 18 }}
            >

              <div className="grid md:grid-cols-[80px_1fr_1fr] gap-8 items-center
              bg-white/70 backdrop-blur-sm rounded-2xl p-6 md:p-8
              shadow-sm hover:shadow-xl transition-all duration-500
              hover:-translate-y-1">

                {/* NUMERO */}

                <div className="text-5xl  text-neutral-300 font-semibold">
                  {service.number}
                </div>


                {/* IMAGE */}

                <div className="relative overflow-hidden rounded-xl h-[550px]">

                  <img
                    src={service.img}
                    loading="lazy"
                    className="w-full h-full object-cover transition duration-700 group-hover:scale-105"
                  />

                  {/* gradient premium */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-60" />

                </div>


                {/* CONTENU */}

                <div className="flex flex-col h-full justify-between">
                  <div>
                    <h3 className="font-light text-lg">Accompagnement</h3>
                    <h3 className="text-3xl mb-7">
                      {service.title}
                    </h3>

                    <p className="text-lg text-neutral-500 font-bold mb-4">
                      {service.price}
                    </p>

                    <p className="text-neutral-600 leading-relaxed whitespace-pre-line">
                      {service.desc}
                    </p>
                  </div>

                  <div className="flex justify-end">
                    <Link
                      to="/contact"
                      className="mt-6 text-sm relative w-fit
                      after:absolute after:left-0 after:-bottom-1 after:h-[1px]
                      after:w-0 after:bg-black after:transition-all
                      hover:after:w-full"
                    >
                      Choisir cette offre →
                    </Link>
                  </div>

                </div>

              </div>

            </motion.div>

          ))}

        </motion.div>

      </section>

      {/* CTA */}

      <motion.section
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="text-center py-28 px-10"
      >

        <h2 className="text-4xl font-light mb-6">
          Parlons de ton projet
        </h2>

        <p className="text-neutral-600 mb-8">
          Créons ensemble des visuels
          qui feront rayonner ton univers.
        </p>

        <div className="flex justify-center gap-4 flex-wrap">

          <Link
            to="/contact"
            className="bg-black text-white px-8 py-4 rounded-full hover:scale-105 transition"
          >
            Let's go !
          </Link>

          <Link
            to="/portfolio"
            className="border border-black px-8 py-4 rounded-full hover:bg-black hover:text-white transition"
          >
            Voir le portfolio
          </Link>

        </div>

      </motion.section>

    </div>
  );
};

export default Services;
